const styles = theme => ({
})

export default styles



// WEBPACK FOOTER //
// ./src/components/results/styles.js